import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Headline3 from './Typography/Heading/Headline3';
import Skeleton from './SkeletonLoader/Skeleton';
import breakpoints from './Theme/breakpoints';

export const WfbCardSkeleton = styled(Skeleton)`
  height: 0;
  transform: none;
  padding-top: 108px;
  padding-bottom: 66.67%;
  :nth-of-type(2) { display: none; }
  :nth-of-type(3) { display: none; }

  @media (min-width: ${breakpoints.md}px) {
    :nth-of-type(2) { display: block; }
  }

  @media (min-width: ${breakpoints.lg}px) {
    :nth-of-type(3) { display: block; }
  }
`;

export const WfbTitle = styled(Headline3)`
  && {
    margin: 16px;
  }
  text-align: center;
`;

export const JobsLandingAds = styled.div`
  && {
    width: auto;
    grid-column-end: span 4;
    align-self: center;

    @media (min-width: ${breakpoints.lg}px) {
      grid-column-end: span 3;
    }
  }
`;

const WfbAdsWrapper = styled.div<{
  gridGap?: string;
}>`
  margin: 0 0 16px;
  padding: 16px 0;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 32px;
  @media (min-width: ${breakpoints.xssm}px) {
    grid-template-columns: repeat(2, 1fr);
    ${({ gridGap }) => (gridGap ? `grid-gap: ${gridGap};` : '')}
  }
  @media (min-width: ${breakpoints.md}px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: ${breakpoints.lg}px) {
    grid-template-columns: repeat(4, 1fr);
  }
  && > a {
    text-align: center;
    & > div {
      display: inline-block;
    }
  }
`;

const wfbAdsPropertyTypes = {
  wfbAds: PropTypes.arrayOf(
    PropTypes.node.isRequired,
  ).isRequired,
  gridGap: PropTypes.string,
  className: PropTypes.string,
};

type WfbAdsProperties = InferProps<typeof wfbAdsPropertyTypes>;

const WfbAds = ({
  wfbAds,
  gridGap,
  className,
}: WfbAdsProperties) => (
  <WfbAdsWrapper
    gridGap={gridGap ?? undefined}
    className={className ?? undefined}
  >
    { wfbAds }
  </WfbAdsWrapper>
);

WfbAds.propTypes = wfbAdsPropertyTypes;

export default WfbAds;
